import React, { useEffect, useState } from "react";
import { FaTimesCircle, FaUsers } from "react-icons/fa";
import { FaTimeline } from "react-icons/fa6";
import { SiTether } from "react-icons/si";
import NftImg from "../assets/img/land-nft1.jpg";


import   Rank0 from "../assets/img/no-rank.png"; // Create this CSS file
import   Rank1 from "../assets/img/rank-1.png"; // Create this CSS file
import   Rank2 from "../assets/img/rank-2.png"; // Create this CSS file
import   Rank3 from "../assets/img/rank-3.png"; // Create this CSS file
import   Rank4 from "../assets/img/rank-4.png"; // Create this CSS file
import { useNavigate } from "react-router-dom";

// Reusable Card (same as AffiliateDetails + optional action button)
const Card = ({ icon, title, value, action }) => (
  <div className="col-lg-6 col-xl-4 col-md-6">
    <div className="stat-card">
      <div className="stat-card-inner">
        <div>
          <div className="stat-icon">{icon}</div>
          <div className="stat-value">{value}</div>
          <div className="stat-title">{title}</div>
        </div>
        {action && <div className="stat-action ms-2">{action}</div>}
      </div>
    </div>
  </div>

);

const getRankImage = (rank) => {
  switch (Number(rank)) {
    case 0: return Rank0;
    case 1: return Rank1;
    case 2: return Rank2;
    case 3: return Rank3;
    case 4: return Rank4;
    default: return null;
  }
};


const YourBonusSummary = ({ objUser, objBonus, objReserveBonus,objlevelstats, objRoyalty,objNftBonus, objcapping,cappingDetails,objReseveTradeBonus, USDTBalance }) => {
  const navigate = useNavigate();

  // Format Balance To 8 Decimals Places
  const [timerValue, setTimerValue] = useState("00:00:00");
  const [lockTimer, setLockTimer] = useState("00:00:00");

  const formatBalance = (balance) => balance ? parseFloat(balance).toFixed(2) : "0.00";
  useEffect(() => {
    const interval = setInterval(() => {
      const nowUTC = Math.floor(Date.now() / 1000); // seconds
      const INDIAN_UTC_OFFSET = 19800; // 5.5 hours
      // const RESET_HOUR = 1; // 1 AM IST
      const RESET_HOUR = 6; // 6 AM IST

      // Convert to IST
      const nowIST = nowUTC + INDIAN_UTC_OFFSET;

      // Find next reset timestamp
      let todayResetTimestamp =
        Math.floor(nowIST / 86400) * 86400 + RESET_HOUR * 3600;

      // If reset time already passed today → next day
      if (nowIST >= todayResetTimestamp) {
        todayResetTimestamp += 86400;
      }

      // Remaining seconds
      let remaining = todayResetTimestamp - nowIST;

      // Convert to HH:MM:SS
      const hrs = String(Math.floor(remaining / 3600)).padStart(2, "0");
      const mins = String(Math.floor((remaining % 3600) / 60)).padStart(2, "0");
      const secs = String(remaining % 60).padStart(2, "0");

      setTimerValue(`${hrs}:${mins}:${secs}`);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
  if (!objlevelstats?.locked || !objlevelstats?.lockUntilTimestamp) {
    setLockTimer("00:00:00");
    return;
  }

  const interval = setInterval(() => {
    const now = Math.floor(Date.now() / 1000);
    let remainingSeconds =
      objlevelstats.lockUntilTimestamp - now;

    if (remainingSeconds <= 0) {
      setLockTimer("00:00:00");
      clearInterval(interval);
      return;
    }

    const hrs = String(Math.floor(remainingSeconds / 3600)).padStart(2, "0");
    const mins = String(
      Math.floor((remainingSeconds % 3600) / 60)
    ).padStart(2, "0");
    const secs = String(remainingSeconds % 60).padStart(2, "0");

    setLockTimer(`${hrs}:${mins}:${secs}`);
  }, 1000);

  return () => clearInterval(interval);
}, [objlevelstats?.locked, objlevelstats?.lockUntilTimestamp]);


  return (
    <section className="services-three-2">

      {/* <div className="services__title">
        <div className="section-title">
          <h2><span>Your Bonus Summary</span> </h2>
        </div>
      </div> */}

      {objBonus ? (

        <>
          <div className="row">

            <div className="col-md-6 mb-3">
              <div className="card bonus-card-sm">

                <div className="card-bdoy">
                  <img src={NftImg} alt="" className="NftImg" />
                  <span className="NftImgSpan"></span>

                  <div className="position-relative">


                    <h4 className="text-white"><span className="text-warning"> Your Affiliate </span> <span className="fw-lighter">  Earnings Summary</span> </h4>


                    <div className="row bs-row1">
                      <Card
                        icon={<FaUsers />}
                        title={
                          <div className="earn-title-wrap">
                            Total Earnings
                          </div>
                        }

                        value={
                          <>
                            {formatBalance(objBonus.totalCreditedBonusUSDT)} <span className="usdt-tag">USDT</span>
                          </>
                        }
                      />

                      <Card
                        icon={<FaUsers />}
                        title={
                          <div className="earn-title-wrap">
                            Referral Earnings
                          </div>
                        }

                        value={
                          <>
                            {formatBalance(objBonus.totalReferralBonus)} <span className="usdt-tag">USDT</span>
                          </>
                        }
                      />

                      <Card
                        icon={<FaUsers />}
                        title={
                          <div className="earn-title-wrap">
                            Level Earnings
                          </div>
                        }

                        value={
                          <>
                            {formatBalance(objBonus.totalLevelBonus)} <span className="usdt-tag">USDT</span>
                          </>
                        }
                      />

                      <Card
                        icon={<FaUsers />}
                        title={
                          <div className="earn-title-wrap">
                            Royalty Earnings
                          </div>
                        }


                        value={
                          <>
                            {formatBalance(objBonus.totalRoyaltyBonus)} <span className="usdt-tag">USDT</span>
                          </>
                        }
                      />


                      <Card
                        icon={<FaUsers />}
                        title={
                          <div className="earn-title-wrap">
                            Total Self Investment
                          </div>
                        }
                        value={
                          <>
                            {formatBalance(objUser.totalSelfPurchasing)} <span className="usdt-tag">USDT</span>
                          </>
                        }
                      />

                      {/* <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                            Available USDT
                          </div>
                        }

                        value={
                          <>
                            {formatBalance(USDTBalance)}
                            <span className="usdt-text"> USDT</span>
                          </>
                        }
                      /> */}

                        <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                            Available Trading Funds
                          </div>
                        }

                        value={
                          <>
                            {formatBalance(cappingDetails.tradeFundAmount)}
                            <span className="usdt-text"> USDT</span>
                          </>
                        }
                      />

                        <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                            Total Deposit Trading Funds
                          </div>
                        }

                        value={
                          <>
                            {formatBalance(cappingDetails.totalDepositFunds)}
                            <span className="usdt-text"> USDT</span>
                          </>
                        }
                      />

                         <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                            2.5X Potential Income 
                          </div>
                        }

                        value={
                          <>
                            {formatBalance(cappingDetails.totalCapping)}
                            <span className="usdt-text"> USDT</span>
                          </>
                        }
                      />

                      
                         <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                            Remaining 2.5X Potential Income
                          </div>
                        }

                        value={
                          <>
                            {formatBalance(cappingDetails.availableCapping)}
                            <span className="usdt-text"> USDT</span>
                          </>
                        }
                      />

                         <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                            Earned 2.5X Potential Income
                          </div>
                        }

                        value={
                          <>
                            {formatBalance(cappingDetails.achivedCapping)}
                            <span className="usdt-text"> USDT</span>
                          </>
                        }
                      />

                         <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                            NFT Trade Fee collected
                          </div>
                        }

                        value={
                          <>
                            {formatBalance(objReseveTradeBonus.totalContributed)}
                            <span className="usdt-text"></span>
                          </>
                        }
                      />

                         <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                            NFT Trade Fee returned
                          </div>
                        }

                        value={
                          <>
                            {formatBalance(objReseveTradeBonus.totalReceived)}
                            <span className="usdt-text"></span>
                          </>
                        }
                      />




                    </div>
                  </div>

                </div>

              </div>
            </div>




            <div className="col-lg-6 mb-3">


              <div className="card bonus-card-sm">

                <div className="card-bdoy">
                  <img src={NftImg} alt="" className="NftImg" />
                  <span className="NftImgSpan"></span>

                  <div className="position-relative">
                    <h4 className="text-white"><span className="text-warning"> NFT </span> <span className="fw-lighter">  Earnings Summary</span> </h4>
                    <div className="row bs-row2">

{/* <>
<style>
{`
.deposit-card-btn{
  color:#000;
  font-weight:600;
  padding:10px 16px;
  border-radius:8px;
  text-align:center;
  cursor:pointer;
  font-size:14px;
  width:130px;
  margin:auto;
  transition:all .25s ease;
  animation:depositColorBlink 2s infinite;
}

.deposit-card-btn:hover{
  transform:scale(1.05);
}

@keyframes depositColorBlink{
  0%{
    background:#f0b90b;
    box-shadow:0 0 6px rgba(240,185,11,0.4);
  }
  33%{
    background:#00ffa6;
    box-shadow:0 0 6px rgba(0,255,166,0.5);
  }
  66%{
    background:#00c8ff;
    box-shadow:0 0 6px rgba(0,200,255,0.5);
  }
  100%{
    background:#f0b90b;
    box-shadow:0 0 6px rgba(240,185,11,0.4);
  }
}
`}
</style>

<Card
  icon={<SiTether size={22} />}
  title={
    <div className="earn-title-wrap">
      Deposit Trading Funds
    </div>
  }
  value={
    <div
      className="deposit-card-btn"
      onClick={() => navigate("/deposit-trading-funds")}
    >
      Deposit
    </div>
  }
/>
</> */}

                     <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                          NFT Trade Earnings
                            <a className="arrow-only-link" href="/Nft-leader-Bonus">
                              <span className="arrow">➜</span>
                            </a>
                          </div>
                        }
 
                        value={
                          <>
                       {formatBalance(objNftBonus.totalNFTOwnerBonus)}
                            <span className="usdt-text"> USDT</span>
                          </>
                        }
                      />

                     <Card  
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                          NFT Level Earnings
                            <a className="arrow-only-link" href="/my-nft-allLevel-bonus">
                              <span className="arrow">➜</span>
                            </a>
                          </div>
                        }
 
                        value={
                        <>
                            {formatBalance(objReserveBonus.totalLevelBonus)}
                            <span className="usdt-text"> USDT</span>
                          </>
                        }
                      />
{/* 
                       <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                          Security Vault Earnings
                          </div>
                        }
 
                        value={
                        <>
                            {formatBalance(objReserveBonus.totalReserveUSDT)}
                            <span className="usdt-text"> USDT</span>
                          </>
                        }
                      /> */}

                      <Card
  icon={<SiTether size={22} />}
  
  title={
    <div className="earn-title-wrap d-flex align-items-center gap-2">
      <span>Royalty Achiever</span>

      {objRoyalty?.rank > 0 && (
        <img
          src={getRankImage(objRoyalty.rank)}
          alt={`Rank ${objRoyalty.rank}`}
          style={{ width: "50px", height: "50px" }}
        />
      )}
    </div>
  }
  
/>



                     <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                          Capping Timer
                          </div>
                        }
 
                        value={
                        <>
                              {timerValue}
                          </>
                        }
                      />

                        <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                           Total Capping
                          </div>
                        }
 
                        value={
                          <>
                       {formatBalance(objcapping.totalCapping)}
                            <span className="usdt-text"> USDT</span>
                          </>
                        }
                      />



                     <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                          Today Available Capping
                          
                          </div>
                        }
 
                        value={
                        <>
                               {formatBalance(objcapping.availableCapping)}
                            <span className="usdt-text"> USDT</span>
                          </>
                        }
                      />  

 
                       <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                            Today Used Capping
                          
                          </div>
                        }

                        value={
                          <>
                            {formatBalance(objcapping.usedCapping)}
                            <span className="usdt-text"> USDT</span>
                          </>
                        }
                      />


                      <Card
  icon={<SiTether size={22} />}
  title={
    <div className="earn-title-wrap">
      Level Locked Timer
    </div>
  }
  value={
    <span
      className={
        objlevelstats?.locked ? "text-danger" : "text-success"
      }
    >
      {lockTimer}
    </span>
  }
/>


                     <Card
                        icon={<SiTether size={22} />}
                        title={
                          <div className="earn-title-wrap">
                            Level Income Status
                          </div>
                        }
                        value={
                          <span
                            className={
                              objlevelstats.locked ? "text-danger" : "text-success"
                            }
                          >
                            {objlevelstats.locked ? "Locked" : "Unlocked"}
                          </span>
                        }
                      />

                    </div>
                  </div>
                  {/* <div className="col-md-3">
                <img src={bgnrftbuild} alt="" className="bgnrftbuild" />
               </div> */}
                </div>
              </div>
            </div>
          </div>
        </>

      ) : (
        <p>No bonus data available.</p>
      )
      }


    </section >
  );
};

export default YourBonusSummary;
